import React from 'react';

import chapterImg1 from '../../../../assets/images/courses/teamplayer&collaboration/chapter7.1.jpg';
import introImg from '../../../../assets/images/courses/teamplayer&collaboration/chapter7.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import { CarouselComponent } from '../../CarouselComponent';
import { MediaBlock } from '../../MediaBlock';

interface TeamPlayersAndCollaborationChapter1 {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersAndCollaborationChapter7: React.FC<TeamPlayersAndCollaborationChapter1> = ({
  chapter,
  onNextChapter,
  totalPages,
}) => {
  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };
  const slidesData = [
    {
      heading: 'Here are five easy ways you can reconfigure your thinking to be more strategic. ',
      paragraph: ``,
      list: [],
      image: '',
    },
    {
      heading: 'Ask strategic questions',
      paragraph: `<p>For example how are we differentiating ourselves to competitors? Where will our growth come from in the next five years? How could we respond to the threat presented by potentially disruptive competitors? </p>`,
      list: [],
      image: '',
    },
    {
      heading: 'Ask why',
      paragraph: `<p>Develop a habit of often asking yourself why am I doing this? This reminds you of the big picture, and aligns your decision making with the team and company goals. </p>`,
      list: [],
      image: '',
    },
    {
      heading: 'Consider alternatives using inversion',
      paragraph: `<p>If you're solving a problem think about the worst case scenario really. For example you explore all the potential risks and concerns, including if this was to fail what could have caused the failure? If we ran out of resources, what would we do? By considering weaknesses in advance you're better able to prepare for and mitigate them before they arise. </p>`,
      list: [],
      image: '',
    },
    {
      heading: 'Identifying gaps',
      paragraph: `<div><p>Address the four priority areas. </p> <ul className="list-decimal pl-5 mb-14 text-xl font-light"><li className="pl-9 mb-7">1. Vision, how does this fit in with the big picture. </li> <li className="pl-9 mb-7">2. Goal, what are the facts and what's the immediate objective?</li> <li className="pl-9 mb-7">3. People, who is impacted, and how have we engaged them and how do they feel about this. </li> <li className="pl-9 mb-7">4. Task, what needs to be done to make this happen?</li></ul></div>`,
      list: [],
      image: '',
    },
    {
      heading: 'Conduct a post-mortem',
      paragraph: `<p>In the world of management, a post-mortem is a post-implementation review. Once you finished a project reflect on what went well and what didn't. What could be better next time? What were the gaps? What do you wish you knew when you started? </p>`,
      list: [],
      image: '',
    },
    {
      heading: 'Summary',
      paragraph: `<p>You can even take this a step further and do this with your team. Doing these regularly helps to build a habit of strategic thinking and the more you do it, the better you get.</p>`,
      list: [],
      image: '',
    },
  ];

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Hone Your Strategy Skills</h2>
        <br />
        <MediaBlock mediaImage={introImg}></MediaBlock>

        <br />
        <p className="text-2xl text-center font-light mt-10 mb-10">
          In today's fast-paced world, learning to think strategically and focus on solutions is
          super important for successful teams. Team members who can think ahead, adapt, and come up
          with creative ideas are valuable.
        </p>
        <p className="text-lg text-left font-semibold mt-10 mb-10">
          This section gives you easy ways to improve your strategic thinking and become more
          solution-oriented. From asking the right questions and considering different options to
          reflecting on what went well and what didn't, these tips will help you and your team
          handle challenges better and achieve more together.
        </p>
        <br />
        <h3 className="text-2xl text-purple-600 font-bold mt-10 mb-1">Hone Your Strategy Skills</h3>

        <div className="md:flex items-center mt-10 mb-10">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg1} alt="" />
          </div>
          <p className="flex-1 leading-7">
            High performing teams need team members who can think strategically to be proactive,
            adaptable, and innovative, and this helps you stand out as a key contributor.
          </p>
        </div>
        <br />
        <div className="border rounded-3xl mr-8">
          <CarouselComponent data={slidesData} isRequired={false} />
        </div>

        <p className="text-2xl text-center font-normal mt-5 mb-10">
          How you show up when you're with your team matters more than you realize. Next, we will
          look at developing your solution-orientation.
        </p>
        <br />
        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Develop Your Solution-Orientation
        </button>
      </div>
    </>
  );
};
